export default "__VITE_ASSET__B49FPVLx__"